import { useState, useEffect, useMemo } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import { Button, Badge } from 'antd'
import { useLocation, useHistory, Link } from 'react-router-dom'
import qs from 'query-string'
import './index.less'

type Props = {}

export interface searchProps {
  /**关键字 */
  w?: string
  /**类目 */
  c?: string
  /**子级类目 */
  cc?: string
  /**是否全选 1 是 0 否 */
  a?: string
  /**分页信息 */
  page?: number
  /**排序 */
  sort?: number
  /**搜索类型 */
  type?: 'app' | 'search'
}

const selector = ({ cart, loading }) => ({
  amount: cart.amount || 0,
})

const Searchbar = (props: Props) => {
  const dispatch = useDispatch()
  const { amount } = useSelector(selector, shallowEqual)

  const location = useLocation()
  const history = useHistory()
  const [word, setWord] = useState('')
  const [sticky, setSticky] = useState(false)

  const onSearch = () => {
    // const search: searchProps = qs.parse(location.search)
    history.push(
      '/search?' + qs.stringify({ page: 1, w: word, sort: 0, type: 'search' })
    )
  }

  useEffect(() => {
    const { w }: searchProps = qs.parse(location.search)
    setWord(w || '')
  }, [location])

  useEffect(() => {
    document.addEventListener('scroll', () => {
      setSticky(document.documentElement.scrollTop >= 64)
    })
    dispatch({ type: 'cart/getShopCartNum' })
  }, [dispatch])

  const searchHide = useMemo(() => {
    const { pathname } = location
    // 提交订单页和订单完成页需要去掉顶部搜索框和购物车按钮 参照pingCode [SHD-4978]
    return ['/settlement', '/order-success'].includes(pathname)
  }, [location])

  return (
    <div className={sticky ? 'search stickySearchBar' : 'search'}>
      <div className="searchbar">
        <div className="logo">
          <Link to="/">
            <img src={require('./logo.png')} alt="" />
          </Link>
        </div>
        {!searchHide && (
          <>
            <div className="search">
              <img src={require('./search.png')} alt="搜索" />
              <input
                placeholder="搜索商品"
                value={word}
                onChange={e => setWord(e.target.value)}
                type="text"
              />
              <Button type="primary" onClick={onSearch}>
                搜索
              </Button>
            </div>
            <div onClick={() => window.open('/cart')} className="cart">
              <Badge count={amount} size="small" showZero>
                <img src={require('./cart.png')} alt="购物车" />
              </Badge>
              <span>我的购物车</span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Searchbar
